export default __webpack_public_path__ + "static/media/contact_new.44988d2f.png";